

































import {Component, Prop, Vue} from 'vue-property-decorator'
import {ID, Resp} from 'simpli-web-sdk'
import MotoristaCancelamentoCarga from '@/model/resource/MotoristaCancelamentoCarga'
import * as Helper from '@/helpers'

@Component
export default class ModalAlertMotoristaCancelamentoCarga extends Vue {

  list: MotoristaCancelamentoCarga[] = []

  get collection() {
    return Helper.collect(MotoristaCancelamentoCarga, this.list)
  }

  close() {
    this.$modal.close('alertMotoristaCancelamentoCarga')
  }

  async openEvent(ids: ID[]) {
    const promise = ids.slice(0, 10).map((id) => new MotoristaCancelamentoCarga().find(id))

    const fetch = async () => {
      const responses = await Promise.all(promise)
      this.list = responses.map((resp: Resp<MotoristaCancelamentoCarga>) => resp.data)
    }

    await this.$await.run(fetch, 'alertMotoristaCancelamentoCarga')

    this.$emit('open')
  }

  closeEvent() {
    this.$emit('close')
  }
}
